import type { ReactNode } from "react";
import { Box, Stack } from "@mui/material";

import type { SiteGeoResponse, TrialGeoResponse } from "api/model";

import PlotTrialPicker from "./PlotTrialPicker";
import SidePanelSectionHeader from "./SidePanelSectionHeader";

interface PlotTrialSectionProps {
  children?: ReactNode;
  isDisabled: boolean;
  sites: SiteGeoResponse[];
  spacing?: number;
  title: string;
  trials: TrialGeoResponse[];
}

const PlotTrialSection: React.FC<PlotTrialSectionProps> = ({
  children,
  isDisabled,
  sites,
  spacing = 2,
  title,
  trials,
}) => {
  return (
    <Stack spacing={spacing} sx={{ mx: -2, position: "relative" }}>
      <Stack spacing={0}>
        <SidePanelSectionHeader inset title={title} />
        <PlotTrialPicker
          isDisabled={isDisabled}
          sites={sites}
          trials={trials}
        />
      </Stack>
      {children ? <Box sx={{ px: 2 }}>{children}</Box> : null}
    </Stack>
  );
};

export default PlotTrialSection;
